import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const HealthPhysicalEducationForms = () => {
  useEffect(() => {
    document.title =
      "Health & Physical Education Forms -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academics </li>
          <li>Health & Physical Education Forms </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Health & Physical Education Forms </h1>
              <h6>Health and Physical Education Forms Classes IX-XII</h6>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Health-ActivityRecord.pdf"
                  target="_blank"
                >
                  {" "}
                  Health And Activity Record
                </Link>{" "}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SewaSelfAppraisal.pdf"
                  target="_blank"
                >
                  Sewa Self Appraisal Form
                </Link>{" "}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SewaPromise.pdf"
                  target="_blank"
                >
                  {" "}
                  Sewa Promise
                </Link>{" "}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SewaHourLog.pdf"
                  target="_blank"
                >
                  {" "}
                  Sewa Hour Log
                </Link>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HealthPhysicalEducationForms;
